"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsubscribeActionCreators = exports.UnsubscribeActionTypes = void 0;
var UnsubscribeActionTypes;
(function (UnsubscribeActionTypes) {
    UnsubscribeActionTypes["Orderbook"] = "Unsubscribe.Orderbook";
    UnsubscribeActionTypes["Tickers"] = "Unsubscribe.Tickers";
    UnsubscribeActionTypes["Currencies"] = "Unsubscribe.Currencies";
    UnsubscribeActionTypes["LastTrades"] = "Unsubscribe.LastTrades";
    UnsubscribeActionTypes["OpenOrders"] = "Unsubscribe.OpenOrders";
    UnsubscribeActionTypes["OrdersHistory"] = "Unsubscribe.OrdersHistory";
    UnsubscribeActionTypes["Balances"] = "Unsubscribe.Balances";
    UnsubscribeActionTypes["Deposits"] = "Unsubscribe.Deposits";
    UnsubscribeActionTypes["Withdrawals"] = "Unsubscribe.Withdrawals";
    UnsubscribeActionTypes["Trades"] = "Unsubscribe.Trades";
    UnsubscribeActionTypes["Candlestick"] = "Unsubscribe.Candlestick";
    UnsubscribeActionTypes["Connection"] = "Unsubscribe.Connection";
})(UnsubscribeActionTypes = exports.UnsubscribeActionTypes || (exports.UnsubscribeActionTypes = {}));
class UnsubscribeActionCreators {
}
exports.UnsubscribeActionCreators = UnsubscribeActionCreators;
UnsubscribeActionCreators.orderbook = (symbol) => ({
    type: UnsubscribeActionTypes.Orderbook,
    symbol,
});
UnsubscribeActionCreators.openOrders = () => ({
    type: UnsubscribeActionTypes.OpenOrders,
});
UnsubscribeActionCreators.ordersHistory = () => ({
    type: UnsubscribeActionTypes.OrdersHistory,
});
UnsubscribeActionCreators.balances = () => ({
    type: UnsubscribeActionTypes.Balances,
});
UnsubscribeActionCreators.lastTrades = (symbol) => ({
    type: UnsubscribeActionTypes.LastTrades,
    symbol,
});
UnsubscribeActionCreators.tickers = () => ({
    type: UnsubscribeActionTypes.Tickers,
});
UnsubscribeActionCreators.trades = () => ({
    type: UnsubscribeActionTypes.Trades,
});
UnsubscribeActionCreators.currencies = () => ({
    type: UnsubscribeActionTypes.Currencies,
});
UnsubscribeActionCreators.deposits = () => ({
    type: UnsubscribeActionTypes.Deposits,
});
UnsubscribeActionCreators.withdrawals = () => ({
    type: UnsubscribeActionTypes.Withdrawals,
});
UnsubscribeActionCreators.candlestick = (symbol) => ({
    type: UnsubscribeActionTypes.Candlestick,
    symbol,
});
UnsubscribeActionCreators.connection = () => ({
    type: UnsubscribeActionTypes.Connection,
});
//# sourceMappingURL=unsubscribe.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/unsubscribe.js
// module id = 110
// module chunks = 0